import { Text } from "@mantine/core";
import { useAppSelector } from "app/hooks";
import { InventoryItem } from "beitary-shared";
import { BSelect } from "components";
import { selectActiveInventoryItems } from "features/admin/inventory/Inventory.slice";
import { ComponentPropsWithoutRef, forwardRef, ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface InventoryItemSelectProps {
  required?: boolean;
  onChange: (value: InventoryItem | undefined) => void;
  error?: ReactNode;
  value?: string; // could be undefined if form has no initial values
  disabled?: boolean;
  clearable?: boolean;
  supplierId: string;
}

export const InventoryItemSelect = (props: InventoryItemSelectProps) => {
  const { t } = useTranslation();
  const items = useAppSelector(selectActiveInventoryItems).filter(
    (i) => i.supplierId === props.supplierId
  );
  const data = items.map((o) => ({ value: o.id, label: o.name, code: o.code }));

  const handleChange = (selectedValue?: string) => {
    if (props.onChange) {
      const item = items.find((i) => i.id === selectedValue);
      props.onChange(item);
    }
  };

  return (
    <BSelect
      {...props}
      itemComponent={SelectItem}
      filter={(value, item) =>
        item.label?.toLowerCase().includes(value.toLowerCase().trim()) ||
        item.code?.toLowerCase().includes(value.toLowerCase().trim())
      }
      label={t("INVENTORY_ITEM")}
      nothingFound={t("NOTHING_FOUND")}
      data={data}
      limit={20}
      onChange={handleChange}
    />
  );
};

interface ItemProps extends ComponentPropsWithoutRef<"div"> {
  label: string;
  code?: string;
}

const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
  ({ code, label, ...others }: ItemProps, ref) => (
    <div ref={ref} {...others}>
      <div>
        <Text>{label}</Text>

        {code && (
          <Text size="xs" color="dimmed">
            {code}
          </Text>
        )}
      </div>
    </div>
  )
);
